import JoinusScreen from './component/joinus';

function joinusScreen() {
    return (
        <JoinusScreen />
    );
}

export default joinusScreen;
